module.exports = __webpack_public_path__ + "img/business-img-3.e37a42d8.png";